import { Box, LinearProgress } from '@mui/material';
import * as styles from './ChecklistProgress.css';

type ChecklistProgressProps = {
  completed: number;
  total: number;
  showLabel?: boolean;
  size?: 'small' | 'medium';
};

export const ChecklistProgress = ({
  completed,
  total,
  showLabel = true,
  size = 'medium',
}: ChecklistProgressProps) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
  const height = size === 'small' ? 4 : 8;

  return (
    <div className={styles.progressContainer}>
      {showLabel && (
        <span className={styles.progressLabel}>{percentage}% complete</span>
      )}
      <Box sx={{ width: '100%' }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          sx={{
            height,
            borderRadius: height / 2,
            backgroundColor: '#E5E7EB',
            '& .MuiLinearProgress-bar': {
              borderRadius: height / 2,
              backgroundColor: '#10B981',
            },
          }}
        />
      </Box>
    </div>
  );
};
